import Select from "../../../../form/Select";
import React from "react";
import {PartnerSelect} from "../../../../../utils/formatters";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels} = props;
    return (hidden || []).indexOf("customer") === -1 && <Select
        label={labels.customer || "Vevő"}
        name="customer"
        component="partner"
        optionsTemplate={PartnerSelect}
        objectValue={true}
        labelKey="name"
        valueKey="partner_id"
        storeType="remote"
        {...props.getProps("customer")}
        value={props.getValue("customer")}
        saveChanges={props.setFieldValue}
    />;
}